module.exports = __webpack_public_path__ + "static/media/cart-trolley-shop-svgrepo-com.ea4434f0.svg";